import React, { useEffect } from "react";
import AOS from "aos";
import page_json from "./config/config.json";
import ContactForm from "./ContactForm";
import { Helmet } from "react-helmet";
import ContactUsButton from "./ContactUsButton";
import HeroComponent from "./HeroComponent";
import TechnologyAlliances from "./TechnologyAlliances";
import MarqueeComponent from "./MarqueeComponent";
import SuccessStoriesList from "./SuccessStoriesList";
import config from '../config';

const textDataUrl = `${page_json.page_jsons.Healthcare}?v=${config.VERSION}`;
const textDataResponse = await fetch(textDataUrl);
const textData = await textDataResponse.json();

function Healthcare() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  const renderFullPageSection = (data, index) => {
    return (
      <div className="full-page-container">
        <div className="container inner-container">
          <div className="content col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <p data-is-light-text={index % 2 === 0}>{data.body.text1}</p>
            <p className="description">{data.description.text}</p>
            <ContactUsButton
              isLightText={index % 2 === 0 ? true : false}
              link="#ContactForm"
              text={data.button.text}
              className={`${index % 2 === 0 ? "dark" : "light"} mt-3`}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 image-wrapper">
            <img src={data.img} alt="img" />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div data-aos="fade-up" className="healthcarepage">
      <Helmet>
        <meta
          name="description"
          content="Leading Digital Transformation in Healthcare"
        />
        <title>Healthcare | Engineersmind</title>
      </Helmet>
      <HeroComponent
        bgImageMobile={textData.layer1.mobilebannerimg}
        bgImage={textData.layer1.img}
        textContent={
          <h1>
            {textData.layer1.heading.text1}{" "}
            <span>
              {textData.layer1.heading.text2}
              <br />
            </span>
            {textData.layer1.heading.text3}
          </h1>
        }
        breadcrumbs={
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="/">Home </a>
            </li>
            <li className="breadcrumb-item">
              <a href="/Industries/Financial-Services">Industries </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Healthcare
            </li>
          </ol>
        }
      />

      <div className="sticky-layers">
        {renderFullPageSection(textData.subHeaderSection.details.detail1, 1)}
      </div>

      <div className="container-fluid ModernPortals  bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.engagingDigitalExperiences.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.engagingDigitalExperiences.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.engagingDigitalExperiences.description1}</p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.engagingDigitalExperiences.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.engagingDigitalExperiences.description2}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>
              {textData.DigitalTransformationAndWorkflowAutomation.title}
            </span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>
                  {
                    textData.DigitalTransformationAndWorkflowAutomation
                      .description1
                  }
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.DigitalTransformationAndWorkflowAutomation.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>
                  {
                    textData.DigitalTransformationAndWorkflowAutomation
                      .description2
                  }
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.DigitalTransformationAndWorkflowAutomation.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.DataTransformationAndAIPoweredInsights.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.DataTransformationAndAIPoweredInsights.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>
                  {textData.DataTransformationAndAIPoweredInsights.description1}
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.DataTransformationAndAIPoweredInsights.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>
                  {textData.DataTransformationAndAIPoweredInsights.description2}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>
              {textData.externalIntegrationsAndInteroperability.title}
            </span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>
                  {
                    textData.externalIntegrationsAndInteroperability
                      .description1
                  }
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.externalIntegrationsAndInteroperability.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>
                  {
                    textData.externalIntegrationsAndInteroperability
                      .description2
                  }
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.externalIntegrationsAndInteroperability.img}
                className="img-fluid ModernPortals-left-img img-full-width"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>
              {textData.streamlinedClaimsAndEligibilityManagement.title}
            </span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.streamlinedClaimsAndEligibilityManagement.img}
                className="img-fluid ModernPortals-left-img img2"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>
                  {
                    textData.streamlinedClaimsAndEligibilityManagement
                      .description1
                  }
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.streamlinedClaimsAndEligibilityManagement.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>
                  {
                    textData.streamlinedClaimsAndEligibilityManagement
                      .description2
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.comprehensiveTechnicalSolutions.title}</span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.comprehensiveTechnicalSolutions.description1}</p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.comprehensiveTechnicalSolutions.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.comprehensiveTechnicalSolutions.description2}</p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.comprehensiveTechnicalSolutions.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>
      <SuccessStoriesList  StoriesList={textData.storiesList} />
      <div className="container-fluid whyChoose ModernPortals">
        <div className="container">
          <h1>
            <span>{textData.WhyChooseEngineersmind.title}</span>
          </h1>
          <p className="text-20 mb-4">
            {textData.WhyChooseEngineersmind.description1}
          </p>
          <div className="pt-0 text-20">
            <ul className="whychoose-points">
              {textData.WhyChooseEngineersmind.points.map((point, index) => {
                return (
                  <li className="" key={index}>
                    <p dangerouslySetInnerHTML={{ __html: point }}></p>
                  </li>
                );
              })}
            </ul>
          </div>
          <p className="pt-2 text-20">
            {textData.WhyChooseEngineersmind.description2}
          </p>
        </div>
      </div>
    </div>
  );
}
export default Healthcare;
